"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var PropTypes = __importStar(require("prop-types"));

var React = __importStar(require("react"));

var ErrorBoundary_1 = __importDefault(require("./components/ErrorBoundary"));

var setupErrorReporter_1 = __importDefault(require("./setupErrorReporter"));

var withTheme_1 = __importDefault(require("./utils/withTheme"));

var VideoPlayer_1 = __importDefault(require("./VideoPlayer"));

var VideoPlayerContainer =
/** @class */
function (_super) {
  __extends(VideoPlayerContainer, _super);

  function VideoPlayerContainer(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {
      errorBoundaryKey: 0,
      receivedError: false
    };
    _this.onFatalError = _this.onFatalError.bind(_this);
    _this.errorReporter = setupErrorReporter_1["default"]();
    return _this;
  }

  VideoPlayerContainer.prototype.componentDidUpdate = function (prevProps) {
    /**
     * If the video ID was changed and we previously received an error,
     * we also want to reset the error boundary state. Here we're using
     * the React key property to re-mount the boundary.
      * https://dev.to/dance2die/resetting-error-boundary-error-state-125k
     */
    if (this.state.receivedError && prevProps.videoId !== this.props.videoId) {
      this.setState({
        errorBoundaryKey: this.state.errorBoundaryKey + 1,
        receivedError: false
      });
    }
  };

  VideoPlayerContainer.prototype.getChildContext = function () {
    return {
      theme: this.props.theme,
      errorReporter: this.errorReporter
    };
  };

  VideoPlayerContainer.prototype.onFatalError = function () {
    this.setState({
      receivedError: true
    });
  };

  VideoPlayerContainer.prototype.render = function () {
    return withTheme_1["default"](this.props.theme, {
      'video-player': true,
      'video-player--16-9': this.props.aspectRatio === '16:9',
      'video-player--9-16': this.props.aspectRatio === '9:16',
      'video-player--square': this.props.aspectRatio === '1:1'
    })(React.createElement(ErrorBoundary_1["default"], {
      key: "outer-error-" + this.state.errorBoundaryKey,
      onFatalError: this.onFatalError,
      className: this.props.className,
      externalLinks: this.props.externalLinks
    }, React.createElement(VideoPlayer_1["default"], __assign({}, this.props))));
  };

  VideoPlayerContainer.childContextTypes = {
    theme: PropTypes.object,
    errorReporter: PropTypes.object
  };
  VideoPlayerContainer.defaultProps = {
    aspectRatio: '16:9',
    externalLinks: true
  };
  return VideoPlayerContainer;
}(React.Component);

exports["default"] = VideoPlayerContainer;